import React, { useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { IconButton } from '@mui/material';
import classNames from 'classnames';
import LogoLockerimRavBariah from 'assets/images/logo_lockerim_rav_bariah.png';

import { useStorage } from 'hooks/useStorage';
import useTranslations from 'hooks/useTranslations';

import SideMenu from 'components/SideMenu/SideMenu';
import Button from 'components/Button/Button';
import { ReactComponent as BurgerLogo } from 'assets/images/burger.svg';

import './Header.scss';

const Header = ({ showGoBackButton = true, IS_MIGRATION = false }) => {
  const [showSideMenu, setShowSideMenu] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const { removeLocalStorageData } = useStorage();
  const { rcTranslate } = useTranslations();

  const homepageLinks = [
    {
      title: 'ראשי',
      link: '/',
    },
    {
      title: 'איך זה עובד',
      link: '/how-it-works',
    },
    {
      title: 'שאלות ותשובות',
      link: '/faq',
    },
  ];

  const showHomepageContent = useMemo(
    () => !location?.pathname?.includes('/onboarding'),
    [location?.pathname]
  );

  const isPackageDelivery = useMemo(
    () => location?.pathname?.includes('/ApproveActionPermission'),
    [location?.pathname]
  );

  const goToMainPage = () => {
    removeLocalStorageData();
    history.push('/');
  };

  const goToLandingPage = () => {
    removeLocalStorageData();
    history.push('/onboarding/landing-page');
  };

  return ReactDOM.createPortal(
    <header className={'header__wrapper'} role="banner">
      <a href="#main" className="skip-link">
        {rcTranslate('a11y.skipToMainContent')}
      </a>
      {showGoBackButton && !showHomepageContent && (
        <button className="header__link" onClick={goToMainPage}>
          {rcTranslate('button.backToMainPage')}
        </button>
      )}

      {showGoBackButton && showHomepageContent && !isPackageDelivery && (
        <div className="header__homepageLeftSide">
          <IconButton
            className="header__burger"
            onClick={() => setShowSideMenu(true)}
            aria-label={rcTranslate('button.openSideMenu')}
          >
            <BurgerLogo />
          </IconButton>

          <Button
            className="header__orderLockerButton"
            title={rcTranslate('button.orderLocker')}
            onClick={goToLandingPage}
            color="white"
          />
        </div>
      )}

      {showHomepageContent && (
        <nav
          className="header__links"
          aria-label="Primary"
          style={IS_MIGRATION ? { visibility: 'hidden' } : {}}
        >
          <ul>
            {homepageLinks.map((item, index) => (
              <li key={index}>
                <Link className="header__link" to={item.link}>
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}

      {showHomepageContent && (
        <SideMenu
          items={homepageLinks}
          show={showSideMenu}
          onClose={() => setShowSideMenu(false)}
        />
      )}

      <button className="header__logo-button" onClick={goToMainPage}>
        <img
          src={LogoLockerimRavBariah}
          alt="logoRavBariah"
          className={classNames('logoImage', {
            'narrow-width': isPackageDelivery,
          })}
        />
      </button>
    </header>,
    document.getElementById('header')
  );
};

export default Header;
